import { BlurIcon, CamIcon, FullscreenIcon, LeaveIcon, MicIcon } from './Icons';

interface Props {
  audioEnabled: boolean;
  videoEnabled: boolean;
  onToggleAudio: () => void;
  onToggleVideo: () => void;
  onLeave: () => void;
  status?: string;
  /** Omitted when the browser cannot do background effects. */
  blurOn?: boolean;
  onToggleBlur?: () => void;
  blurLoading?: boolean;
  /** Omitted when the browser cannot put an element fullscreen. */
  fullscreen?: boolean;
  onToggleFullscreen?: () => void;
}

export function ControlBar({
  audioEnabled,
  videoEnabled,
  onToggleAudio,
  onToggleVideo,
  onLeave,
  status,
  blurOn,
  onToggleBlur,
  blurLoading,
  fullscreen,
  onToggleFullscreen,
}: Props) {
  return (
    <div className="controlbar">
      <button
        className="control"
        aria-pressed={audioEnabled}
        onClick={onToggleAudio}
        title={audioEnabled ? 'Mute microphone (space)' : 'Unmute microphone (space)'}
      >
        <MicIcon off={!audioEnabled} />
        <span className="visually-hidden">{audioEnabled ? 'Mute microphone' : 'Unmute microphone'}</span>
      </button>

      <button
        className="control"
        aria-pressed={videoEnabled}
        onClick={onToggleVideo}
        title={videoEnabled ? 'Turn camera off' : 'Turn camera on'}
      >
        <CamIcon off={!videoEnabled} />
        <span className="visually-hidden">{videoEnabled ? 'Turn camera off' : 'Turn camera on'}</span>
      </button>

      {onToggleBlur ? (
        <button
          className="control"
          aria-pressed={!blurOn}
          onClick={onToggleBlur}
          disabled={blurLoading}
          title={blurOn ? 'Turn background blur off' : 'Blur my background'}
        >
          <BlurIcon off={!blurOn} />
          <span className="visually-hidden">
            {blurOn ? 'Turn background blur off' : 'Blur my background'}
          </span>
        </button>
      ) : null}

      {/* Neutral, not aria-pressed-red: red means off-air here, and a window
          that is merely not fullscreen is not a problem to flag. */}
      {onToggleFullscreen ? (
        <button
          className="control neutral"
          aria-pressed={fullscreen}
          onClick={onToggleFullscreen}
          title={fullscreen ? 'Exit fullscreen' : 'Go fullscreen'}
        >
          <FullscreenIcon on={fullscreen} />
          <span className="visually-hidden">{fullscreen ? 'Exit fullscreen' : 'Go fullscreen'}</span>
        </button>
      ) : null}

      <button className="control danger" onClick={onLeave} title="Leave the meeting">
        <LeaveIcon />
        Leave
      </button>

      {status ? <span className="faint">{status}</span> : null}
    </div>
  );
}
